export interface GridColumnConfiguration {
  key: string;
  width: string;
}

export enum DefaultGridColumnFixedWidths {
  XS = '80px',
  S = '160px',
  M = '240px',
  L = '320px',
  XL = '400px',
}
